import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "metismenu"

// Wraps the admin sidebar's <ul> with metisMenu — the actual jQuery plugin
// Skote's own template uses for its collapsible nested menu (parent items
// with a chevron that expands to reveal children, e.g. "Produits" ->
// Liste des produits / Catégories / Attributs). Importing "metismenu"
// registers $.fn.metisMenu as a side effect (standard jQuery plugin
// pattern), so no factory call is needed here, unlike select2. Its look
// comes from Skote's own SCSS (skote/custom/structure/_vertical.scss), not
// from metisMenu.css.
//
// Pinned to metismenu@3.0.7 in package.json rather than the newer 3.1.0 —
// that version bumped its jquery peer dependency to >=4.0.0, which this
// project can't use (DataTables/Select2 need jQuery 3.x here). 3.0.7
// requires jquery ^3.4.1, matching both this project's jQuery version and
// the jQuery 3.7.1 Skote itself actually ships in its own dist bundle.
export default class extends Controller {
  connect() {
    this.highlightActiveItem()
    this.$el = $(this.element)
    this.$el.metisMenu()
  }

  disconnect() {
    if (this.$el && this.$el.data("metisMenu")) this.$el.metisMenu("dispose")
  }

  // Marks the entry of the current page (longest matching path wins, so
  // /admin/products/12/edit lights up "Produits" and not "Tableau de bord"),
  // and opens the group it belongs to — same logic as KoPilot's sidebar.
  highlightActiveItem() {
    const currentPath = window.location.pathname
    let bestMatch = null
    let bestMatchLength = -1

    this.element.querySelectorAll("a[href]").forEach((link) => {
      const href = link.getAttribute("href")
      if (!href || href === "#" || href.startsWith("javascript:")) return

      const linkPath = new URL(href, window.location.origin).pathname
      const isMatch = linkPath === currentPath || currentPath.startsWith(linkPath + "/")
      if (isMatch && linkPath.length > bestMatchLength) {
        bestMatch = link
        bestMatchLength = linkPath.length
      }
    })
    if (!bestMatch) return

    bestMatch.classList.add("active")
    bestMatch.closest("li")?.classList.add("mm-active")

    const subMenu = bestMatch.closest("ul.sub-menu")
    if (subMenu) {
      subMenu.classList.add("mm-show")
      const group = subMenu.closest("li")
      group?.classList.add("mm-active")
      group?.querySelector(":scope > a")?.classList.add("mm-active")
    }
  }
}
